import React from 'react';
import EmailFieldProto from './email-proto';


export default function renderStringInList(id, props) {
    return <EmailFieldProto renderMode="list" id={id} {...props} />;
}